// src/components/navigation/NavItem.jsx
// Individual menu item component with badge/warning support

import React from 'react';
import { NavLink } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';

function NavItem({ item, badge, warning, userType, onNavigate, collapsed }) {
  // External link (opens in new tab)
  if (item.externalUrl) {
    const url = item.urls[userType] || item.urls.installer;

    if (collapsed) {
      return (
        <li className="nav-item-collapsed" title={item.label}>
          <a
            className="text-light nav-collapsed-link"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className={item.icon}></i>
          </a>
        </li>
      );
    }

    return (
      <li>
        <a
          className="text-light"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onNavigate}
        >
          <i className={`${item.icon} nav-item-icon`}></i>
          {item.label}
        </a>
      </li>
    );
  }

  // Custom isActive check that includes query params
  const isActive = (match, loc) => {
    if (!match) return false;

    const [routePath, routeQuery] = item.route.split('?');
    const currentPath = loc.pathname;
    const currentQuery = loc.search.replace('?', '');

    if (routePath !== currentPath) return false;

    if (routeQuery) {
      return routeQuery === currentQuery;
    }

    return !currentQuery;
  };

  // Collapsed mode — icon only with badge dot
  if (collapsed) {
    return (
      <li className="nav-item-collapsed" title={item.label}>
        <NavLink
          activeClassName="active"
          className="text-light nav-collapsed-link"
          to={item.route}
          isActive={isActive}
        >
          <i className={item.icon}></i>
          {badge && <span className="nav-badge-dot">{badge}</span>}
          {warning && <span className="nav-warning-dot" title="Action Required">!</span>}
        </NavLink>
      </li>
    );
  }

  // Expanded mode — icon + text + badge (right-aligned)
  return (
    <li>
      <NavLink
        activeClassName="active"
        className="text-light nav-item-expanded"
        to={item.route}
        isActive={isActive}
        onClick={onNavigate}
      >
        <span className="nav-item-left">
          <i className={`${item.icon} nav-item-icon`}></i>
          {warning && (
            <span className="nav-warning-icon" title="Action Required">&#9888;&#65039;</span>
          )}
          {item.label}
        </span>
        {badge && (
          <Badge pill variant="danger" className="nav-badge-right">
            {badge}
          </Badge>
        )}
      </NavLink>
    </li>
  );
}

export default NavItem;
